export default __webpack_public_path__ + "static/media/in-the-spotlight-casa-tookan.27f0e887.png";